// Core
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';

// Chakra imports
import { Box } from '@chakra-ui/react';

// Components
import UserPurchase from './UserPurchase';
import UserPurchasesDetails from './UserPurchasesDetails';
import usePermissionStatusByKey from '../../../hooks/usePermissionStatusByKey';

function UserPurchases(props) {
  const { path } = useRouteMatch();

  const isUserPurchases = usePermissionStatusByKey('GET:/admin/user-purchases');
  const isUserPurchasesStats = usePermissionStatusByKey(
    'GET:/admin/user-purchases/stats',
  );
  const isUserPurchase = usePermissionStatusByKey(
    'GET:/admin/user-purchases/:id',
  );

  return (
    <>
      <Box>
        <Switch>
          {(isUserPurchase || isUserPurchasesStats) && (
            <Route
              path={`${path}/:id`}
              render={() => <UserPurchasesDetails />}
            />
          )}

          {(isUserPurchases || isUserPurchasesStats) && (
            <Route path={`${path}`} render={() => <UserPurchase />} />
          )}

          <Redirect from={`${path}*`} to={`${path}`} />
        </Switch>
      </Box>
    </>
  );
}

export default UserPurchases;
